<template>
  <div class="appeal-escrow__popup">
    <div class="appeal-escrow__popup-title">{{i18n.cont_appeal_to_escrow()}}</div>
    <form @submit.prevent="submit"
          class="appeal-escrow__form">
      <div class="appeal-escrow__row">
        <div class="appeal-escrow__field">
          <h3 class="appeal-escrow__field-title">{{i18n.lbl_note()}}</h3>
          <textarea-field v-model="form.note" />
        </div>

      </div>
      <div class="appeal-escrow__submit-wrapper">
        <md-button type="submit" class="md-primary"
          :disabled="isPending"
        >{{ i18n.lbl_submit() }}</md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { i18n } from '@js/i18n'
import { vuexTypes } from '@vuex/types'

import { ErrorHandler } from '@js/errors/error_handler'
import { EventDispatcher } from '@js/events/event_dispatcher'
import FormMixin from '@com/mixins/form.mixin'
import FileField from '@com/fields/FileField'
import { contractsService } from '@api/contracts.service'

export default {
  components: { FileField },
  props: ['contractId'],
  mixins: [FormMixin],
  data: _ => ({
    i18n,
    form: {
      note: ''
    }
  }),

  computed: {
    ...mapGetters([
      vuexTypes.accountTypeI
    ])
  },

  methods: {
    async submit () {
      if (!await this.isValid()) return
      this.disable()
      try {
        await contractsService.addDetails({
          contractID: this.contractId,
          details: {
            note: this.form.note
          }
        })
        EventDispatcher.dispatchShowSuccessEvent(i18n.cont_appeal_success())
        this.$emit('load-contract')
      } catch (e) {
        console.error(e)
        ErrorHandler.processUnexpected(e)
      }
      this.enable()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .appeal-escrow__popup-title {
    line-height: 1.625rem;
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }

  .appeal-escrow__form {
    display: flex;
    flex-direction: column;
  }

  .appeal-escrow__row {
    display: flex;
    justify-content: space-between;
  }

  .appeal-escrow__field {
    width: 100%;
  }

  .appeal-escrow__submit-wrapper {
    text-align: right;
    margin-right: -1.5rem;
  }

  .appeal-escrow__field-title {
    margin-bottom: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/modals/Contracts.AppealEscrow.vue